
import React, { useState } from 'react';
import './DietSection.css';
import NutritionCalculator from './NutritionCalculator'; // Import the Nutrition Calculator

const dietDetails = [
    // Sunday
    {
      day: "Sunday",
      meal: "Breakfast",
      dish: "Avocado Toast with Egg",
      ingredients: ["Whole grain bread", "Avocado", "Egg", "Olive oil"],
    },
    {
      day: "Sunday",
      meal: "Lunch",
      dish: "Grilled Chicken with Quinoa",
      ingredients: ["Grilled Chicken", "Quinoa", "Spinach", "Olive oil"],
    },
    {
      day: "Sunday",
      meal: "Snack",
      dish: "Greek Yogurt with Berries",
      ingredients: ["Greek yogurt", "Blueberries", "Strawberries", "Honey"],
    },
    {
      day: "Sunday",
      meal: "Dinner",
      dish: "Salmon with Brown Rice and Broccoli",
      ingredients: ["Salmon", "Brown Rice", "Broccoli", "Lemon"],
    },
  
    // Monday
    {
      day: "Monday",
      meal: "Breakfast",
      dish: "Oatmeal with Banana",
      ingredients: ["Oatmeal", "Banana", "Almond Milk"],
    },
    {
      day: "Monday",
      meal: "Lunch",
      dish: "Grilled Chicken with Rice",
      ingredients: ["Grilled Chicken", "Rice", "Broccoli"],
    },
    {
      day: "Monday",
      meal: "Snack",
      dish: "Apple with Almond Butter",
      ingredients: ["Apple", "Almond Butter"],
    },
    {
      day: "Monday",
      meal: "Dinner",
      dish: "Stir-fried Tofu with Vegetables",
      ingredients: ["Tofu", "Carrots", "Bell Peppers", "Soy Sauce"],
    },
  
    // Tuesday
    {
      day: "Tuesday",
      meal: "Breakfast",
      dish: "Smoothie Bowl",
      ingredients: ["Frozen Berries", "Banana", "Almond Milk", "Granola"],
    },
    {
      day: "Tuesday",
      meal: "Lunch",
      dish: "Turkey Wrap with Hummus",
      ingredients: ["Whole Wheat Wrap", "Turkey", "Hummus", "Lettuce"],
    },
    {
      day: "Tuesday",
      meal: "Snack",
      dish: "Cottage Cheese with Pineapple",
      ingredients: ["Cottage Cheese", "Pineapple"],
    },
    {
      day: "Tuesday",
      meal: "Dinner",
      dish: "Baked Cod with Sweet Potatoes",
      ingredients: ["Cod", "Sweet Potatoes", "Olive Oil", "Garlic"],
    },
  
    // Wednesday
    {
      day: "Wednesday",
      meal: "Breakfast",
      dish: "Chia Pudding with Berries",
      ingredients: ["Chia Seeds", "Almond Milk", "Blueberries", "Maple Syrup"],
    },
    {
      day: "Wednesday",
      meal: "Lunch",
      dish: "Chicken Caesar Salad",
      ingredients: ["Grilled Chicken", "Romaine Lettuce", "Caesar Dressing", "Parmesan"],
    },
    {
      day: "Wednesday",
      meal: "Snack",
      dish: "Carrot Sticks with Hummus",
      ingredients: ["Carrots", "Hummus"],
    },
    {
      day: "Wednesday",
      meal: "Dinner",
      dish: "Beef Stir-Fry with Brown Rice",
      ingredients: ["Beef", "Broccoli", "Brown Rice", "Soy Sauce"],
    },
  
    // Thursday
    {
      day: "Thursday",
      meal: "Breakfast",
      dish: "Scrambled Eggs with Spinach",
      ingredients: ["Eggs", "Spinach", "Olive Oil"],
    },
    {
      day: "Thursday",
      meal: "Lunch",
      dish: "Tuna Salad with Whole Grain Bread",
      ingredients: ["Tuna", "Greek Yogurt", "Whole Grain Bread", "Lettuce"],
    },
    {
      day: "Thursday",
      meal: "Snack",
      dish: "Mixed Nuts",
      ingredients: ["Almonds", "Walnuts", "Cashews"],
    },
    {
      day: "Thursday",
      meal: "Dinner",
      dish: "Baked Chicken with Vegetables",
      ingredients: ["Chicken Breast", "Zucchini", "Carrots", "Olive Oil"],
    },
  
    // Friday
    {
      day: "Friday",
      meal: "Breakfast",
      dish: "Pancakes with Maple Syrup",
      ingredients: ["Whole Wheat Flour", "Eggs", "Maple Syrup", "Baking Powder"],
    },
    {
      day: "Friday",
      meal: "Lunch",
      dish: "Grilled Salmon Salad",
      ingredients: ["Salmon", "Spinach", "Cherry Tomatoes", "Balsamic Dressing"],
    },
    {
      day: "Friday",
      meal: "Snack",
      dish: "Protein Bar",
      ingredients: ["Oats", "Protein Powder", "Peanut Butter"],
    },
    {
      day: "Friday",
      meal: "Dinner",
      dish: "Shrimp Stir-Fry with Vegetables",
      ingredients: ["Shrimp", "Bell Peppers", "Soy Sauce", "Ginger"],
    },
  
    // Saturday
    {
      day: "Saturday",
      meal: "Breakfast",
      dish: "Yogurt Parfait",
      ingredients: ["Greek Yogurt", "Granola", "Mixed Berries", "Honey"],
    },
    {
      day: "Saturday",
      meal: "Lunch",
      dish: "Quinoa Bowl with Avocado and Beans",
      ingredients: ["Quinoa", "Avocado", "Black Beans", "Lime"],
    },
    {
      day: "Saturday",
      meal: "Snack",
      dish: "Dark Chocolate with Almonds",
      ingredients: ["Dark Chocolate", "Almonds"],
    },
    {
      day: "Saturday",
      meal: "Dinner",
      dish: "Vegetable Soup with Whole Wheat Bread",
      ingredients: ["Carrots", "Potatoes", "Celery", "Whole Wheat Bread"],
    },
    
  ];
  
const DietSection = () => {
  const [selectedDay, setSelectedDay] = useState("Sunday");
  const [selectedMeal, setSelectedMeal] = useState("Breakfast");

  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const meals = ["Breakfast", "Lunch", "Snack", "Dinner"];

  // Filter the diet details based on selected day and meal
  const currentDiet = dietDetails.find(
    (diet) => diet.day === selectedDay && diet.meal === selectedMeal
  );

  return (
    <div className="diet-section">
      <h2 style={{backgroundColor:"white"}}>Select Day and Meal</h2>

      <div className="day-buttons">
        {days.map((day) => (
          <button
            key={day}
            className={selectedDay === day ? "active" : ""}
            onClick={() => setSelectedDay(day)}
          >
            {day}
          </button>
        ))}
      </div>

      <div className="meal-buttons">
        {meals.map((meal) => (
          <button
            key={meal}
            className={selectedMeal === meal ? "active" : ""}
            onClick={() => setSelectedMeal(meal)}
          >
            {meal}
          </button>
        ))}
      </div>

      <div className="diet-details">
        <h3>{selectedDay} - {selectedMeal}</h3>
        {currentDiet ? (
          <>
            <p><strong>Dish:</strong> {currentDiet.dish}</p>
            <p><strong>Ingredients:</strong> {currentDiet.ingredients.join(", ")}</p>

            {/* Integrate the Nutrition Calculator */}
            <NutritionCalculator ingredients={currentDiet.ingredients} />
          </>
        ) : (
          <p>No meal data available.</p>
        )}
      </div>
    </div>
  );
};

export default DietSection;
